"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    PREVIEW_PARAM_NAME: true
};
Object.defineProperty(exports, "PREVIEW_PARAM_NAME", {
    enumerable: true,
    get: function() {
        return _editorialFetching.PREVIEW_PARAM_NAME;
    }
});
var _editorialFetching = require("@ori/editorial-fetching");
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _defaultTranslations[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _defaultTranslations[key];
        }
    });
});
var _plpFeature = require("./plpFeature");
Object.keys(_plpFeature).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _plpFeature[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _plpFeature[key];
        }
    });
});
